export const STATUS_CODE_200_MAPPER = Object.freeze({
  0: 'La tua offerta Enel Casa è stata attivata con successo',
  '001': 'POD non esistente o non legato a una offerta di fornitura attiva',
  '002': 'POD già associato ad una offerta Enel Casa',
});

export const STATUS_CODE_ERROR_MAPPER = Object.freeze({
  'Generic error': 'Errore imprevisto, riprovare più tardi',
  'Missing mandatory fields': 'Codice fiscale e POD sono obbligatori',
});

export const HEADER_MESSAGE = Object.freeze({
  INACTIVE: 'La tua offerta Enel Casa non è ancora attiva, per attivare l\'offerta e iniziare a usufruire dei benefici associa la tua fornitura a Enel Casa',
  NORMAL: 'Conferma l\'attivazione dell\'offerta Enel Casa',
  INACTIVE_MESSAGE: 'Ci dispiace, ma non ci risulta tu abbia ancora sottoscritto il servizio Enel Casa.',
});
